import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RegisterComponent } from './auth/register/register.component';
import { loginGuard } from '@guards/login.guard';
import { EmailConfirmationComponent } from './auth/email-confirmation/email-confirmation.component';
import { RegistrationPendingComponent } from './auth/registration-pending/registration-pending.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import {
  backendTokenGuard,
  registrationPendingGuard,
} from '@guards/auth-flow.guard';

export const routes: Routes = [
  {
    path: 'vehicle-passport/:workshopPublicId',
    loadComponent: () =>
      import('./vehicle-passport/vehicle-passport.component').then(
        (module) => module.VehiclePassportComponent,
      ),
  },
  {
    path: 'capture/vehicle-evidence',
    loadChildren: () =>
      import('./vehicle-evidence-capture/vehicle-evidence-capture.routes').then(
        (module) => module.routes,
      ),
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'confirm-email',
    component: EmailConfirmationComponent,
    canActivate: [loginGuard, backendTokenGuard],
  },
  {
    path: 'registration-pending',
    component: RegistrationPendingComponent,
    canActivate: [loginGuard, registrationPendingGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [loginGuard, backendTokenGuard],
  },
  {
    path: '',
    canLoad: [AuthGuard],
    loadChildren: () => import('./home/home.routes').then((m) => m.routes),
  },
];
